<template>
    <v-container >
        <h2 class="my-text-black" style="text-align: center;">Bienvenido al servicio de reintegros de ACEAPP</h2>
        <v-row justify="center">
            <v-col cols="12" md="6" sm="6">
                <v-divider id="divider"></v-divider>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" md="4" sm="6">
                <v-btn 
                    id="boton-verde" 
                    block 
                    :disabled="!estaLogueado()"
                    @click="this.$router.push('/reintegros/info-paciente')"
                >Solicitar reintegro</v-btn>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" md="4" sm="6">
                <v-btn 
                    id="boton-verde" 
                    block
                    :disabled="!estaLogueado()"
                    @click="this.$router.push('/reintegros/listado-solicitudes-reintegro')"
                >Ver mis reintegros</v-btn>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" md="4" sm="6">
                <v-btn 
                    id="boton-verde" 
                    block
                    :disabled="!estaLogueado()"
                    @click="this.$router.push('/reintegros/carga-datos')"
                ><v-icon icon="mdi mdi-arrow-left"></v-icon> Otro paciente</v-btn>
            </v-col>
        </v-row>
        <v-container class="d-flex justify-center align-center">
          <Loader v-if="cargando"></Loader>
        </v-container>
    </v-container>
    <AlertComponent
      :title="alertTitle"
      :text="alertText"
      :alertType="alertType"
      :showAlert="showAlert"
      @close="showAlert = false"
    />
</template>

<style src="../assets/general.css"></style>

<script>
    export default{
        data() {
            return {
                cargando:false,
                showAlert:false,
                alertTitle: '',
                alertText: '',
                alertType: '',
            }
        },
        methods:{
            estaLogueado(){
                return this.$store.getters.isAuthenticated;
            }
        }
    }
</script>